import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'xe-utils';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import moment from 'moment';
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx';

import '@/assets/styles/index.scss';
import '@/icons';


document.title = '入学教育系统';

moment.locale('zh-cn');

VXETable.formats.add('Moment', ({ cellValue }, format = 'YYYY-MM-DD HH:mm:ss') => {
  return cellValue ? moment(cellValue).format(format) : '';
});

Vue.use(ElementUI);
Vue.use(VXETable);
Vue.use(VueQuillEditor);

Vue.prototype.$moment = moment;

VXETable.use(VXETablePluginExportXLSX);

Vue.prototype.$XModal = VXETable.modal;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
